import { render, staticRenderFns } from "./yiyi.vue?vue&type=template&id=41a0d101&scoped=true&"
import script from "./yiyi.vue?vue&type=script&lang=js&"
export * from "./yiyi.vue?vue&type=script&lang=js&"
import style0 from "./yiyi.vue?vue&type=style&index=0&id=41a0d101&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a0d101",
  null
  
)

export default component.exports